import moment from 'moment'
import { indicadorService } from '@/_services/index.api'

const colorsLocal = [
  '#208eb7',
  '#8ce3e6',
  '#0a4f4e',
  '#21f0b6',
  '#069668',
  '#afc6fe',
  '#374475',
  '#5f80da',
  '#208eb7',
  '#8ce3e6',
  '#0a4f4e',
  '#21f0b6',
  '#069668',
  '#afc6fe',
  '#374475',
  '#5f80da',
]

export function obtenerMensajeAleatorio() {
  var mensajes = [
    'Consultando los servidores lunares...',
    'Conectando con nuestros satélites en órbita...',
    'Estableciendo comunicación con las estaciones espaciales...',
    'Verificando la señal desde nuestra base en la Luna...',
    'Sincronizando con los satélites en el espacio profundo...',
    'Explorando las bases lunares en busca de datos...',
    'Recopilando información desde las órbitas más distantes...',
    'Comunicándonos con las sondas en el espacio exterior...',
    'Navegando por el cosmos en busca de respuestas...',
    'Buscando señales en las fronteras de la galaxia...',
    'Accediendo a la red de satélites en tiempo real...',
    'Monitoreando los datos desde nuestra base lunar...',
    'Comprobando la conexión a la red interplanetaria...',
    'Explorando el espacio profundo en busca de respuestas...',
    'Sintonizando los canales de comunicación estelar...',
    'Consultando la base de datos en las órbitas terrestres...',
    'Conectando con las estaciones espaciales en el vacío...',
    'Transmitiendo señales desde la superficie lunar...',
    'Verificando la señal desde las lunas exteriores...',
    'Explorando el cosmos en busca de información...',
    'Rastreando las señales cósmicas en tiempo real...',
    'Navegando por el espacio en busca de pistas...',
    'Accediendo a los registros de nuestros satélites...',
    'Monitoreando la base lunar en busca de datos...',
    'Comprobando la conexión con el universo...',
    'Explorando el espacio profundo en busca de pistas...',
    'Sintonizando con las estrellas distantes...',
    'Consultando la base de datos intergaláctica...',
    'Conectando con nuestros observatorios en el espacio...',
    'Transmitiendo señales desde estaciones en la Luna...',
    'Verificando la señal desde las órbitas planetarias...',
    'Explorando el universo en busca de respuestas...',
    'Rastreando las ondas cósmicas en tiempo real...',
    'Navegando por el espacio interestelar en busca de pistas...',
    'Accediendo a los registros de las misiones espaciales...',
    'Monitoreando la base lunar en tiempo real...',
    'Comprobando la conexión con los confines del espacio...',
    'Explorando el espacio profundo en busca de señales...',
    'Sintonizando con las emisiones estelares...',
    'Consultando la base de datos galáctica...',
    'Conectando con nuestras naves exploratorias...',
    'Transmitiendo información desde las bases lunares...',
    'Verificando la señal desde las órbitas interplanetarias...',
    'Explorando el cosmos en busca de pistas cósmicas...',
    'Rastreando las emisiones espaciales en tiempo real...',
    'Navegando por el universo en busca de conocimiento...',
    'Accediendo a los registros de nuestros observatorios...',
    'Monitoreando la actividad en la base lunar...',
    'Comprobando la conexión con las estaciones espaciales...',
    'Explorando el espacio profundo en busca de respuestas...',
    'Sintonizando con las estrellas en busca de señales...',
    'Consultando la base de datos universal...',
  ]

  var mensajeAleatorio = mensajes[Math.floor(Math.random() * mensajes.length)]
  return mensajeAleatorio
}

export function ScrollToElement(theElement) {
  var selectedPosX = 0
  var selectedPosY = 0

  while (theElement != null) {
    selectedPosX += theElement.offsetLeft
    selectedPosY += theElement.offsetTop
    theElement = theElement.offsetParent
  }

  window.scrollTo(selectedPosX, selectedPosY)
}

export function getElementsByAttribute(attr, value) {
  if ('querySelectorAll' in document) {
    return document.querySelectorAll('[' + attr + "='" + value + "']")
  } else {
    var els = document.getElementsByTagName('*'),
      result = []

    for (var i = 0, _len = els.length; i < _len; i++) {
      var el = els[i]

      if (el.hasAttribute(attr)) {
        if (el.getAttribute(attr) === value) result.push(el)
      }
    }

    return result
  }
}

export function areArraysEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false
  }

  const sortedArr1 = arr1.slice().sort((a, b) => {
    if (a.id === null) {
      return 1 // a.id es nulo, colocar a al final
    } else if (b.id === null) {
      return -1 // b.id es nulo, colocar b al final
    } else {
      return a.id.localeCompare(b.id) // Comparar valores GUID
    }
  })
  const sortedArr2 = arr2.slice().sort((a, b) => {
    if (a.id === null) {
      return 1 // a.id es nulo, colocar a al final
    } else if (b.id === null) {
      return -1 // b.id es nulo, colocar b al final
    } else {
      return a.id.localeCompare(b.id) // Comparar valores GUID
    }
  })

  for (let i = 0; i < sortedArr1.length; i++) {
    const value1 = sortedArr1[i]
    const value2 = sortedArr2[i]

    if (JSON.stringify(value1) !== JSON.stringify(value2)) {
      return false
    }
  }

  return true
}

export function difDias(fechaIni, fechaFin) {
  var ini = moment(moment(fechaIni).format('YYYY-MM-DD')).add(1, 's')
  var fin = moment(moment(fechaFin).format('YYYY-MM-DD')).add(1, 's')
  var dif = fin.diff(ini, 'days')
  return dif
}

export const Fn = {
  validaRut: function (rutCompleto) {
    if (!/^[0-9]+-[0-9kK]{1}$/.test(rutCompleto)) return false
    var tmp = rutCompleto.split('-')
    var digv = tmp[1]
    var rut = tmp[0]
    if (digv == 'K') digv = 'k'
    return Fn.dv(rut) == digv ? true : false
  },
  dv: function (T) {
    var M = 0,
      S = 1
    for (; T; T = Math.floor(T / 10)) S = (S + (T % 10) * (9 - (M++ % 6))) % 11
    return S ? S - 1 : 'k'
  },
}

export function validateEmail(email) {
  if (email.match(/^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/)) {
    return true
  } else {
    return false
  }
}

export function formattedDate(value, format = 'DD-MM-YYYY') {
  try {
    return moment(value).format(format)
  } catch (error) {
    console.error(error)
    return null
  }
}

export function getStyleByEstadoHito(estado) {
  switch (estado) {
    case 'Pendiente':
      return 'warning'
    case 'Facturado':
      return 'success'
    case 'Sin Estado':
      return 'info'
  }
}

export function getStyleByEstadoPresupuesto(estado) {
  switch (estado) {
    case 'Pausado':
      return 'warning'
    case 'En Proceso':
      return 'primary'
    case 'Anulado':
      return 'danger'
    case 'Aprobado':
      return 'success'
    case 'Cerrado':
      return 'dark'
  }
}

export function getStyleByEstadoMovimiento(estado) {
  switch (estado) {
    case 'Pausado':
      return 'warning'
    case 'Rechazado':
      return 'danger'
    case 'Aprobado':
      return 'success'
  }
}

export function getStyleByEstadoTrato(estado) {
  switch (estado) {
    case 'Sincronizado':
      return 'warning'
    case 'En Proyecto':
      return 'success'
  }
}

export function getStyleByEstadoProyecto(estado) {
  switch (estado) {
    case 'Cerrado':
      return 'success'
    case 'Asignado':
      return 'warning'
    case 'Iniciado':
      return 'primary'
    case 'Anulado':
      return 'danger'
  }
}

export function getStyleByEstadoCotizacion(estado) {
  switch (estado) {
    case 'Aprobado':
      return 'success'
    case 'Creando':
      return 'primary'
    case 'Plantilla':
      return 'info'
    case 'Eliminada':
    case 'Anulada':
      return 'danger'
  }
}

export function getStyleByTipoPrioridad(estado) {
  switch (estado) {
    case 'Alta':
      return 'danger'
    case 'Media':
      return 'warning'
    case 'Baja':
      return 'primary'
    case 'No Aplica':
      return 'info'
  }
}

export function isRenderAdmin() {
  try {
    let currentUser = JSON.parse(localStorage.currentUser)
    if (currentUser.perfil.find(x => x.nombre == 'Administrador')) return true
  } catch (error) {
    return false
  }
  return false
}

export function arrayRandomColor(length) {
  let colors = new Array(length)
  for (let i = 0; i < colors.length; i++) {
    colors[i] = colorsLocal[i]
  }
  return colors
}

export function nameMonth(month) {
  switch (month) {
    case 1:
      return 'Enero'
    case 2:
      return 'Febrero'
    case 3:
      return 'Marzo'
    case 4:
      return 'Abril'
    case 5:
      return 'Mayo'
    case 6:
      return 'Junio'
    case 7:
      return 'Julio'
    case 8:
      return 'Agosto'
    case 9:
      return 'Septiembre'
    case 10:
      return 'Octubre'
    case 11:
      return 'Noviembre'
    case 12:
      return 'Diciembre'
    default:
      return 'NonSet'
  }
}

export async function copyToClipboard(text) {
  try {
    await navigator.clipboard.writeText(text)
    alert('Se ha copiado valor en el portapapeles.')
  } catch ($e) {
    alert('No se ha podido copiar el valor en el portapapeles.')
  }
}

export async function convertFromUF(montoUF, convertirA) {
  try {
    if (convertirA !== 'CLP' && convertirA !== 'USD') {
      throw new Error('El parámetro convertirA debe ser "CLP" o "USD".')
    }
    let montoConvert = 0

    await indicadorService.getByIndicador('uf').then(async response => {
      if (response.status != 200) return
      const valorUF = response.data.serie[0].valor
      if (convertirA === 'CLP') {
        montoConvert = montoUF * valorUF
      } else if (convertirA === 'USD') {
        await indicadorService.getByIndicador('dolar').then(response => {
          if (response.status != 200) return

          const valorDolar = response.data.serie[0].valor
          const montoPesos = montoUF * valorUF
          montoConvert = montoPesos / valorDolar
        })
      }
    })
    return montoConvert
  } catch (error) {
    console.error('Error al convertir el monto:', error)
    throw error
  }
}

export async function convertToUFfromCLP(montoCLP) {
  try {
    let montoConvert = 0

    await indicadorService.getByIndicador('uf').then(async response => {
      if (response.status != 200) return
      const valorUF = response.data.serie[0].valor
      montoConvert = montoCLP / valorUF
    })

    return montoConvert
  } catch (error) {
    console.error('Error al convertir el monto:', error)
    throw error
  }
}

export async function convertToUFfromUSD(montoUSD) {
  try {
    let montoConvert = 0
    let valorUf = 0
    let valorDolar = 0
    await indicadorService.getByIndicador('uf').then(async response => {
      if (response.status != 200) return
      valorUf = response.data.serie[0].valor
    })
    await indicadorService.getByIndicador('dolar').then(async response => {
      if (response.status != 200) return
      valorDolar = response.data.serie[0].valor
    })
    montoConvert = (montoUSD * valorDolar) / valorUf

    return montoConvert
  } catch (error) {
    console.error('Error al convertir el monto:', error)
    throw error
  }
}

export function generateUIRandom() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c == 'x' ? r : (r & 0x3) | 0x8
    return v.toString(16)
  })
}
